<div class="@container mt-8">
    @let currentStep = activeStep();
    @let stepCount = steps().length;
    @let useHorizontalLayout = stepCount <= horizontalLayoutMaxSteps;
    <ol
        class="flex list-none! flex-col pb-6"
        [ngClass]="useHorizontalLayout ? '@2xl:grid @2xl:px-8 @4xl:px-16' : ''"
        [style.grid-template-columns]="
            'repeat(' + stepCount + ', minmax(0, 1fr))'
        "
        [attr.aria-label]="ariaLabel()">
        @for (
            step of steps();
            track step.value;
            let index = $index;
            let first = $first;
            let last = $last
        ) {
            <li
                class="relative grid w-full min-w-0 grid-cols-[1.85rem_minmax(0,1fr)] items-center gap-x-6 py-4"
                [ngClass]="
                    useHorizontalLayout
                        ? '@2xl:block @2xl:min-w-0 @2xl:px-2 @2xl:py-0 @2xl:text-center'
                        : ''
                "
                [attr.aria-current]="
                    step.value === currentStep ? 'step' : null
                ">
                <span class="sr-only">
                    {{
                        'shared.nonInteractiveStepper.position'
                            | translate
                                : {
                                      current: index + 1,
                                      total: stepCount,
                                  }
                    }}
                    @if (step.value < currentStep) {
                        {{
                            'shared.nonInteractiveStepper.completed' | translate
                        }}
                    } @else if (step.value === currentStep) {
                        {{ 'shared.nonInteractiveStepper.current' | translate }}
                    } @else {
                        {{
                            'shared.nonInteractiveStepper.upcoming' | translate
                        }}
                    }
                </span>
                <span
                    aria-hidden="true"
                    class="relative z-10 flex size-[1.85rem] shrink-0 items-center justify-center rounded-full text-xs"
                    [ngClass]="[
                        step.value <= currentStep
                            ? 'bg-brand-red text-white'
                            : 'bg-gray-300 text-white',
                        useHorizontalLayout ? '@2xl:mx-auto' : '',
                    ]">
                    {{ step.value }}
                </span>
                <span
                    class="col-start-2 row-start-1 block min-w-0 max-w-prose break-words text-left text-sm leading-[1.3]"
                    [ngClass]="
                        useHorizontalLayout
                            ? '@2xl:mx-auto @2xl:mt-4 @2xl:w-full @2xl:px-2 @2xl:text-center @2xl:leading-[1.2]'
                            : ''
                    ">
                    {{ step.labelKey | translate }}
                </span>
                @if (!last) {
                    <span
                        aria-hidden="true"
                        class="absolute bottom-0 left-[calc(0.925rem-1px)] top-[calc(50%+1.175rem)] w-0.5"
                        [ngClass]="[
                            step.value < currentStep
                                ? 'bg-brand-red'
                                : 'bg-gray-300',
                            useHorizontalLayout
                                ? '@2xl:bottom-auto @2xl:left-[calc(50%+1.45rem)] @2xl:right-[calc(-50%+1.45rem)] @2xl:top-[calc(0.925rem-1px)] @2xl:h-0.5 @2xl:w-auto'
                                : '',
                        ]">
                    </span>
                }
                @if (!first) {
                    <span
                        aria-hidden="true"
                        class="absolute bottom-[calc(50%+1.175rem)] left-[calc(0.925rem-1px)] top-0 block w-0.5"
                        [ngClass]="[
                            step.value <= currentStep
                                ? 'bg-brand-red'
                                : 'bg-gray-300',
                            useHorizontalLayout ? '@2xl:hidden' : '',
                        ]">
                    </span>
                }
            </li>
        }
    </ol>
</div>
